/**
 * "Memória da IA" (docs/refactor/17-memoria-das-ias.md): the person's own switches, the same in Configurações ›
 * Conta and in the "o que só você decide" step.
 *
 *  - Memória da IA (on by default): what their agents are asked and answer is kept, for their AIs to look back on
 *    through the MCP (and for them to read on the web), for the plan's days of memory.
 *  - Compartilhar com as IAs do projeto (on by default): the project's other AIs may read it too.
 *  - With the memory off, the older "Suas respostas na web" (for them alone, a week) is what is left.
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useI18n } from '../lib/i18n'

export function MemorySwitches({ itemClassName = 'row row--tight' }: { itemClassName?: string }) {
  const { t } = useI18n()
  const queryClient = useQueryClient()
  const { data: me } = useQuery({ queryKey: ['me'], queryFn: api.auth.me, staleTime: 5 * 60_000 })
  const done = () => void queryClient.invalidateQueries({ queryKey: ['me'] })
  const memory = useMutation({ mutationFn: (body: { aiMemory?: boolean; shareMemory?: boolean }) => api.me.memory(body), onSuccess: done })
  const replies = useMutation({ mutationFn: (keep: boolean) => api.me.keepReplies(keep), onSuccess: done })
  if (!me?.developerId) return null
  const on = Boolean(me.aiMemory)

  return (
    <>
      <label className={itemClassName}>
        <input type="checkbox" checked={on} disabled={memory.isPending} onChange={(event) => memory.mutate({ aiMemory: event.target.checked })} />
        <span className="stack" style={{ gap: 2 }}>
          <strong className="small">{t('memory.title')}</strong>
          <span className="tiny muted">{t('memory.label', { days: me.memoryDays ?? 3 })}</span>
        </span>
      </label>
      <label className={itemClassName}>
        <input type="checkbox" checked={on && Boolean(me.shareMemory)} disabled={!on || memory.isPending} onChange={(event) => memory.mutate({ shareMemory: event.target.checked })} />
        <span className="stack" style={{ gap: 2 }}>
          <strong className="small">{t('memory.share')}</strong>
          <span className="tiny muted">{t('memory.shareLabel')}</span>
        </span>
      </label>
      {!on && !me.repliesCollected && (
        <label className={itemClassName}>
          <input type="checkbox" checked={Boolean(me.keepOwnReplies)} disabled={replies.isPending} onChange={(event) => replies.mutate(event.target.checked)} />
          <span className="stack" style={{ gap: 2 }}>
            <strong className="small">{t('replies.own.title')}</strong>
            <span className="tiny muted">{t('replies.own.label')}</span>
          </span>
        </label>
      )}
    </>
  )
}
